import '../css/main.less';

const { deliveryendpoint, ordereendpoint, redirurl, ANALYTICS_ID,
	GATSBY_FINGERPRINT_API_KEY,
	GATSBY_FPJS_PROXY_URL,
	GATSBY_FPJS_AGENT_DOWNLOAD_PATH,
	GATSBY_FPJS_BEHAVIOR_PATH,
	GATSBY_FPJS_GET_RESULT_PATH,
	IDENTITY_ENDPOINT
} = process.env;

const FINGERPRINT_LOCALSTORAGE_ID = 'FINGERPRINTIDLOCAL'
const FP_API_KEY = GATSBY_FINGERPRINT_API_KEY
const FPJS_AGENT_DOWNLOAD_PATH = GATSBY_FPJS_AGENT_DOWNLOAD_PATH
const FPJS_BEHAVIOR_PATH = GATSBY_FPJS_BEHAVIOR_PATH
const FPJS_GET_RESULT_PATH = GATSBY_FPJS_GET_RESULT_PATH
const FPJS_PROXY_URL = GATSBY_FPJS_PROXY_URL

const onlineStores = ['960','970','980','1060','1070','1080','2960','2970','2980','3960','3970','3980'];

const getFingerprintId = () => localStorage.getItem(FINGERPRINT_LOCALSTORAGE_ID);

var selectedDate = '';
var activeDate = '';
var currentDate = '';
var twoFactorData = null;
var otpVerified = false;
var rtgOrderData = {};


const identifyFingerprint = async() => {
	const segmentUser = typeof window?.analytics?.user === 'function' && window.analytics?.user()
	const email = rtgOrderData?.EmailAddress || segmentUser?.traits?.()?.email
	const zipcode = segmentUser?.traits?.()?.zipcode || rtgOrderData?.DeliveryAddress?.Zip;
	const user_id = urlParam('userId');

	if (!segmentUser?.traits?.()?.fingerprint_id) {
	  try {
		const fingerprint_id = getFingerprintId()
		let userId = user_id || segmentUser?.id?.() || fingerprint_id
		const traitsData = {
		  email,
		  zipcode,
		  fingerprint_id,
		}

		//window.analytics?.identify(userId, traitsData, {}, identifyUserCallback)
		if(!user_id || user_id == '')
		  userId = await getUserIdentity(email, fingerprint_id, zipcode);

		localStorage.setItem("ajs_user_id", userId);

		dataLayer.push({
		  event: "segment_identify",
		  userId,
		  ...traitsData,
		});

		dataLayer.push({
		  event: "segment_loaded",
		  segment_loaded: true,
		  pathname: window.location.pathname,
		  segmentId: userId,
		  fingerprint_id,
		});



	  } catch (e) {
		throw new Error({ e, message: 'Error identifying Segment user. (fingerprint_id)' })
	  }
	} else {
	  let fingerprint_id = segmentUser?.traits?.()?.fingerprint_id;
	  let userId = fingerprint_id;
	  dataLayer.push({
		event: "segment_loaded",
		segment_loaded: true,
		pathname: window.location.pathname,
		segmentId: userId,
		fingerprint_id,
	  });
	  //identifyUserCallback()
	  if(!fingerprint_id || fingerprint_id == '')
		userId = await getUserIdentity(email, fingerprint_id, zipcode);
	  localStorage.setItem("ajs_user_id", userId);
	}
  }
  const identifyUserCallback = () => {}

  const initFingerPrint = async () => {
	try {
	  let fingerprintId = getFingerprintId()
	  console.log(fingerprintId)
	  if (isEmpty(fingerprintId)) {
		const baseUrl = `${FPJS_PROXY_URL}/${FPJS_BEHAVIOR_PATH}`
		const fingerprintOptions = {
		  endpoint: [`${baseUrl}/${FPJS_GET_RESULT_PATH}?region=us`, FingerprintJS.defaultEndpoint],
		  apiKey: FP_API_KEY,
		  scriptUrlPattern: [
			`${baseUrl}/${FPJS_AGENT_DOWNLOAD_PATH}?apiKey=${FP_API_KEY}&version=3&loaderVersion=3.8.3`,
			FingerprintJS.defaultScriptUrlPattern,
		  ],
		}
		const fingerPrint = await FingerprintJS.load(fingerprintOptions)
		const result = await fingerPrint.get()
		const { visitorId } = result
		fingerprintId = visitorId
		localStorage.setItem(FINGERPRINT_LOCALSTORAGE_ID, fingerprintId)
	  }
	  if(window?.analytics)
		identifyFingerprint(fingerprintId)

	} catch (error) {
	  console.log(`Loading Fingerprint failed. ${error.message}`)
	}
  }

  const getUserIdentity = async (email, fingerprint_id, zip) => {
	let body = {
	  email: email,
	  fingerprintId: fingerprint_id,
	  attributes: {
		  zipcode: zip
	  }
	}
	let identityRes = await fetch(`${IDENTITY_ENDPOINT}/user`, {
	  method: "POST",
	  headers: {
		"Content-Type": "application/json",
	  },
	  body: JSON.stringify(body),
	});
	let userData = await identityRes.json();
	let userId = userData?.userId;
	console.log(userData);

	return userId;
  };


  function isEmpty(value){
	var isEmptyObject = function(a) {
	  if (typeof a.length === 'undefined') { // it's an Object, not an Array
		var hasNonempty = Object.keys(a).some(function nonEmpty(element){
		  return !isEmpty(a[element]);
		});
		return hasNonempty ? false : isEmptyObject(Object.keys(a));
	  }

	  return !a.some(function nonEmpty(element) { // check if array is really not empty as JS thinks
		return !isEmpty(element); // at least one element should be non-empty
	  });
	};
	return (
	  value == false
	  || typeof value === 'undefined'
	  || value == null
	  || (typeof value === 'object' && isEmptyObject(value))
	);
  }

const urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null){
		return null;
    }
    else {
		return decodeURI(results[1]) || 0;
    }
}


/*Load Calendar*/
function loadcalendar(target, available_dates){

	let today = new Date();
	let currentMonth = today.getMonth();
	let currentYear = today.getFullYear();
	let activedate = '';

	let minYear = (currentYear-30);
	let maxYear = (currentYear+10);

	let initCal = `<div class="calendar-wrap hide">
	<h3 id="calendar-title" class="calendar-title"></h3>
	<div class="calendar-buttons">
	<button  aria-label="Previous Month" aria-describedby="calendar-instructions calendar-title" class="prev">&nbsp;</button>
	<button  aria-label="Next Month" aria-describedby="calendar-instructions calendar-title"  class="next">&nbsp;</button>
	</div>
	<div class="calendar-table">
	<div class="weekdays"></div>
	<div class="days"></div>
	</div>
	</div>
	`;

	let calwrap = document.querySelector(".calendar-wrap");
	if(typeof(calwrap)!="undefined" && calwrap!=null){
		calwrap.remove();
		document.addEventListener("click", function(e){
			let t = e.target;
			if(t.closest(".calendar-wrap")==null && t != target && !t.classList.contains("ravacal")){
				calwrap = document.querySelector(".calendar-wrap");
				if(typeof(calwrap)!="undefined" && calwrap!=null){
					//calwrap.remove();
				}
			}
		});
	}


	document.querySelector(".main-section .calendar-holder").insertAdjacentHTML('beforeend',initCal);
	/*set calendar position on screen based on the target*/
	calwrap = document.querySelector(".calendar-wrap");

	calwrap.style.top = (target.offsetTop + target.offsetHeight)+'px';
	calwrap.style.left = target.offsetLeft+'px';


	var start_month, end_month, end_year, start_val, end_val = '';

	available_dates.map((dt,i) => {
		let dtarr = dt.split('-');
		if(i==0){
			start_month = parseInt(dtarr[1]);
			currentMonth = parseInt(dtarr[1])-1;
			currentYear = parseInt(dtarr[0]);
		}
		end_month = parseInt(dtarr[1])-1;
		end_year = parseInt(dtarr[0]);
	});
	start_val = start_month+(currentYear*12);
	end_val = end_month+(end_year*12);


	if(selectedDate != ''){
		currentMonth = parseInt(selectedDate.getMonth());
		currentYear = parseInt(selectedDate.getFullYear());
	}
	else{
		currentMonth = parseInt(available_dates[0].split('-')[1])-1;
		currentYear = parseInt(available_dates[0].split('-')[0]);
	}



	showCalendar(calwrap,activedate,currentMonth,currentYear, available_dates);

	if(currentMonth+(currentYear*12) < start_val)
		document.querySelector('.calendar-buttons .prev').classList.add('disabled');
	if(currentMonth+(currentYear*12)+2 > end_val)
		document.querySelector('.calendar-buttons .next').classList.add('disabled');

	document.querySelector('.calendar-buttons .next').addEventListener("click",function(){
		if(currentMonth+(currentYear*12)+1 > end_val)
			return false;
		document.querySelector('.calendar-buttons .prev').classList.remove('disabled');
		document.querySelector('.calendar-buttons .next').classList.remove('disabled');
		if(currentMonth+(currentYear*12)+2 > end_val)
			document.querySelector('.calendar-buttons .next').classList.add('disabled');
		currentYear = (currentMonth === 11) ? parseInt(currentYear) + 1 : currentYear;
		currentMonth = (parseInt(currentMonth) + 1) % 12;

		showCalendar(calwrap,activedate,currentMonth, currentYear, available_dates);
	});

	document.querySelector('.calendar-buttons .prev').addEventListener("click",function(){
		if(currentMonth+(currentYear*12) < start_val)
			return false;
		document.querySelector('.calendar-buttons .next').classList.remove('disabled');
		document.querySelector('.calendar-buttons .prev').classList.remove('disabled');
		if(currentMonth+(currentYear*12)-1 < start_val)
			document.querySelector('.calendar-buttons .prev').classList.add('disabled');
		currentYear = (currentMonth === 0) ? parseInt(currentYear) - 1 : currentYear;
		currentMonth = (currentMonth === 0) ? 11 : parseInt(currentMonth) - 1;

		showCalendar(calwrap,activedate,currentMonth, currentYear, available_dates);
	});

	calwrap.addEventListener("click",function(e){
		if(e.target.classList.contains('disabled'))
			return false;

		if(e.target.classList.contains("day") ||e.target.parentNode.classList.contains("day")){
			const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	        const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
			let theday = e.target;
			let d = theday.getAttribute("data-date");
			let m = theday.getAttribute("data-month");
			let y = theday.getAttribute("data-year");
			Array.from(document.querySelectorAll('.date-picker')).map(item => {item.classList.remove('selected'); item.removeAttribute("aria-selected"); item.setAttribute("tabindex", "-1");});
			e.target.classList.add('selected','sel');
			e.target.setAttribute("aria-selected", "true");
			e.target.setAttribute("tabindex", "0");
			if(m!=null){
				if(!e.target.innerText){
					e.target.value = m+'/'+d+'/'+y;
				}else{
					e.target.innerText = m+'/'+d+'/'+y;
				}

				let event = document.createEvent('Event');
				event.initEvent('input', true, true);
				//target.dispatchEvent(event);
				document.querySelector('#selected_date').value = `${y}-${pad(m,2)}-${pad(d,2)}`;
				selectedDate = `${y}-${pad(m,2)}-${pad(d,2)}`;
				activeDate = `${y}-${m}-${d}`;

				let tmpdate = new Date(selectedDate+'T12:00:00Z');
				let theDeliveryDate = weekdays[tmpdate.getDay()]+ ', '+months[tmpdate.getMonth()]+' '+tmpdate.getDate()+', '+tmpdate.getFullYear();
				document.querySelector('.read-terms p .delivery-date').innerHTML = theDeliveryDate;

			}
			//calwrap.remove();
		}
	});

}

function showCalendar(calwrap,activedate, month, year, available_dates, target) {
	let today = new Date();
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let firstDay = ( new Date( year, month ) ).getDay();
    let weekdisplay = calwrap.querySelector(".calendar-table .weekdays");
	weekdisplay.innerHTML = `<div class="row">
	<div id="day0" aria-label="Sunday"  class="day">Su</div>
	<div id="day1" aria-label="Monday"  class="day">Mo</div>
	<div id="day2" aria-label="Tuesday" class="day">Tu</div>
	<div id="day3" aria-label="Wednesday" class="day">We</div>
	<div id="day4" aria-label="Thursday" class="day">Th</div>
	<div id="day5" aria-label="Friday" class="day">Fr</div>
	<div id="day6" aria-label="Saturday" class="day">Sa</div>
	</div>`;

	let daydisplay = calwrap.querySelector(".calendar-table .days");
	daydisplay.innerHTML='';

    let monthAndYear = calwrap.querySelector(".calendar-wrap .calendar-title");
    monthAndYear.innerHTML = months[month] + " " + year;

	// creating all cells
	let date = 1;
	let daysinmonth = 32 - new Date(year, month, 32).getDate();

	for ( let i = 0; i < 6; i++ ) {
		let row = document.createElement("div");
		row.classList.add("row");
		if (date > daysinmonth) { break;}
		for ( var j = 0; j < 7; j++ ) {
			if ( i === 0 && j < firstDay ) {
				let cell = document.createElement( "div" );
				cell.classList.add("day");
				row.append(cell);
			} else if (date > daysinmonth) {
				let cell = document.createElement( "div" );
				cell.classList.add("day");
				row.append(cell);
			} else {
				let cell = document.createElement( "div" );
				cell.classList.add("day");
				cell.setAttribute("role", "button");
				cell.setAttribute("tabindex", "-1");
				cell.setAttribute("data-date", date);
				cell.setAttribute("data-month", month + 1);
				cell.setAttribute("data-year", year);
				cell.setAttribute("data-month_name", months[month]);
				cell.classList.add("date-picker");
				cell.innerHTML = "<span>" + date + "</span>";
                if ( date == today.getDate() && year == today.getFullYear() && month == today.getMonth() ) {
                    cell.classList.add("selected");
                }else if(activedate !=''  && date == activedate[1] && month == (activedate[0]-1) && year == activedate[2]){
	                 cell.classList.add("selected","sel");
					 cell.setAttribute("aria-selected", "true");
					 cell.setAttribute("tabindex", "0");
                }

				if(activeDate == '' && selectedDate !=''  && date == selectedDate.getDate() && month == selectedDate.getMonth() && year == selectedDate.getFullYear()){
					cell.classList.add("selected","sel");
					cell.setAttribute("aria-selected", "true");
					cell.setAttribute("tabindex", "0");
			   	}

				let activeDateArr = activeDate.split('-');

				if(activeDateArr.length  && date == parseInt(activeDateArr[2]) && month == (parseInt(activeDateArr[1])-1) && year == parseInt(activeDateArr[0])){
					console.log(cell)
					cell.classList.add("selected","sel");
					cell.setAttribute("aria-selected", "true");
					cell.setAttribute("tabindex", "0");
			   	}

				if(!available_dates.includes(`${year}-${pad(month + 1,2)}-${pad(date,2)}`)){
					cell.classList.add("disabled");
					cell.setAttribute("aria-disabled", "true");
				}
				else {
					cell.setAttribute("aria-describedby", "calendar-title");
					cell.setAttribute("aria-labelledby", "day"+j);
				}
                row.append(cell);
                date++;
            }
        }
        daydisplay.append(row);
    }
	document.querySelector('.calendar-wrap').classList.remove('hide');
	bindCalendarEvents();
}

function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

function addSnippet() {
	var script = document.createElement("script");
	script.text = `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${ANALYTICS_ID}";;analytics.SNIPPET_VERSION="4.15.3";
	analytics.load("${ANALYTICS_ID}");
	analytics.page();
	}}();`;
	document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', async _ => {
	addSnippet();
	const orderId  = urlParam('orderId');
	const zipcode  = urlParam('zipcode');
	const orderKey = urlParam('orderKey');

	if(orderKey){
		let action = '/ordersHistoryByKey';
		//let orderRes = await fetch(`${ordereendpoint}${action}?orderId=${orderId}&zipcode=${zipcode}`);
		let orderRes = await fetch(`${ordereendpoint}${action}?orderKey=${orderKey}`);
		let orderData = await orderRes.json();

		if(orderRes.status !== 200){
			showErrors(orderData.error.message);
		}
	 	else if (!orderData.AbleToReschedule) {
			showErrors(`Currently we are unable to schedule your order online, please contact customer care at 800-766-6786 for assistance.<br/><a href="${`${redirurl}?orderKey=${orderData.orderKey}`}">Return to Order Details</a>`);
			document.querySelector('.main-section').classList.add('hide');
			return false;
		}
		else {
			let orderphone = orderData.Customer.PhoneNumber ? orderData.Customer.PhoneNumber : orderData.PhoneNumber;
			orderphone = escapePhone(orderphone);
			Array.from(document.querySelectorAll('.verify-phone-txt')).map(el => { el.innerHTML = orderphone; });
			rtgOrderData = orderData;
			initFingerPrint();
			//let orderemail = escapeEmail(orderData.EmailAddress);
			//document.querySelector('.verify-email-txt').innerHTML = orderemail;

			document.querySelector('.step-1 .btn-next').addEventListener('click', async function(e){
				this.setAttribute("disabled","disabled");
				sendCode();
			});

			document.querySelector('.step-2 .btn-next').addEventListener('click', async function(e){
				this.setAttribute("disabled","disabled");
				verifyCode();
			});


			let delivery_dates = await getDeliveryDates(orderData);

			let calendarDates = [];
			calendarDates = orderData.DeliveryType == 'P' ? delivery_dates.pickupCalendar : delivery_dates.deliveryCalendar;

			if(!calendarDates || !calendarDates.length) {
				//showErrors('Unable to retrieve calendar dates');
				document.querySelector('.main-section').classList.add('hide');
				return false;
			}
			else {
				buildInterface(orderData);
				document.querySelector('section.loading').classList.add('hide');
				document.querySelector('.main-section').classList.remove('hide');
				loadcalendar('date-selection', calendarDates);

				document.querySelector('.modal').classList.remove('hide');
				document.querySelector('.modal-holder').classList.remove('hide');

				/*let datesItems = [];
				calendarDates.map(dt => {
					datesItems.push(`<li class="date-item" data-dt="${dt}">${formatDate(dt)}</li>`);
				});
				document.querySelector('.date-list').insertAdjacentHTML('afterbegin', datesItems.join(''));

				$('.date-list').slick({
					slidesToShow: 5,
					arrows: true,
					infinite: false,
					responsive: [
						{
						  breakpoint: 1024,
						  settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							infinite: false,
						  }
						},
						{
						  breakpoint: 600,
						  settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						  }
						},
						{
						  breakpoint: 480,
						  settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						  }
						}
					  ]
				});

				if(orderData.DeliveryDate){
					let DeliveryDate = orderData.DeliveryDate;
					DeliveryDate = DeliveryDate.split('T')[0];
					if(document.querySelector(`.date-item[data-dt="${DeliveryDate}"]`)){
						document.querySelector(`.date-item[data-dt="${DeliveryDate}"]`).classList.add('active');
						var slideno = document.querySelector(`.date-item[data-dt="${DeliveryDate}"]`).dataset.slickIndex;
						$('.date-list').slick('slickGoTo', slideno - 1);
					}
				}*/
			}
		}

		document.addEventListener('keydown', async function(e){
			console.log(e.key)
			if(e.key === 'Enter' || e.key === ' '){

			}
		});

		function escapePhone(phone){
			console.log(phone)
			phone = phone.replace('/','').replace('NPI','');
			return `${phone.substring(0,3)}-***-*${phone.substring((phone.length-3), phone.length+1)}`;
		}

		function escapeEmail(email){
			return `${email.substring(0,2)}***${email.substring(5, email.length+1)}`;
		}

		async function sendCode () {
			twoFactorData = null;
			//let phone = escapePhone(orderData.PhoneNumber);
			if(document.querySelector('[name="verify-method"]:checked')){
				let channel = document.querySelector('[name="verify-method"]:checked').value;
				document.querySelector('.send-errors').innerHTML = '';
				if(channel != ''){
					let action = '/triggerOtp';

					const dataObj = {
						orderKey,
						channel
					};
					let dataRes = await fetch(`${ordereendpoint}${action}`, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json'
						},
						body: JSON.stringify(dataObj)
					});

					let resData = await dataRes.json();

					//console.log(dataRes)
					if(dataRes.status == '200'){
						document.querySelector('.step-1').classList.add('hide');
						document.querySelector('.step-2').classList.remove('hide');
						//returns SID
						twoFactorData = resData;
					}
					else if(dataRes.status == '429'){
						document.querySelector('.send-errors').innerHTML = 'Too many attempts. Please wait 10 minutes to retry';
					}
					else {
						if(resData.error && resData.error.message){
							console.log(resData.error.message);
						}else{
							if(resData[0] && resData[0].error && resData[0].error[0] && resData[0].error[0].message){
								console.log(resData[0].error[0].message);
							}
						}
					}
					document.querySelector('.step-1 .btn-next').removeAttribute("disabled");
				}else{
					document.querySelector('.send-errors').innerHTML = 'Please select a verification option.';
					document.querySelector('.step-1 .btn-next').removeAttribute("disabled");
				}
			}else{
				document.querySelector('.send-errors').innerHTML = 'Please select a verification option.';
				document.querySelector('.step-1 .btn-next').removeAttribute("disabled");
			}
		}

		async function verifyCode() {
			let otp = document.querySelector('[name="verify-code"]').value;
			document.querySelector('.verify-errors').innerHTML = '';
			document.getElementById('verify-code').classList.remove('error');
			if(otp != ''){
				let action = '/verifyOtp';
				let dataRes = await fetch(`${ordereendpoint}${action}?orderKey=${orderKey}&otp=${otp}`);
				let resData = await dataRes.json();
				console.log(resData)
				console.log(dataRes)
				if(dataRes.status == '200'){

					document.querySelector('.step-2').classList.add('hide');
					//returns SID
					//twoFactorData = resData;
					otpVerified = true;
					document.querySelector('.modal').classList.add('hide');
					document.querySelector('.modal-holder').classList.add('hide');
				}
				else if(dataRes.status == '429'){
					document.querySelector('.verify-errors').innerHTML = 'Too many attempts. Please wait 10 minutes to retry';
					document.getElementById('verify-code').classList.add('error');
				}
				else {
					console.log(resData.error.message)
					document.querySelector('.verify-errors').innerHTML = 'Verification failed';
					document.getElementById('verify-code').classList.add('error');
				}
				document.querySelector('.step-2 .btn-next').removeAttribute("disabled");
			}else{
				document.querySelector('.verify-errors').innerHTML = 'Please enter verification code.';
				document.querySelector('.step-2 .btn-next').removeAttribute("disabled");
			}
		}


		document.addEventListener('click', async function(e){
			if(e.target.className == 'resend-code'){
				e.target.innerText = 'Sending Code...';
				await sendCode();
				e.target.innerText = 'Code Sent';
			}
			if(e.target.className == 'diff-method'){
				document.querySelector('.step-1').classList.remove('hide');
				document.querySelector('.step-2').classList.add('hide');
			}

			if(e.target.className == 'date'){
				e.target.closest('.date-item').click();
			}
			if(e.target.className.indexOf('date-item') !== -1) {
				//handle change for date

				selectedDate = e.target.dataset.dt;
				Array.from(document.querySelectorAll('.date-item.active')).map(el => {
					el.classList.remove('active');
				})
				e.target.classList.add('active');
			}
			if(e.target.id == 'update-button' && !e.target.classList.contains('disabled')) {
				document.querySelector('.has-errors').classList.add('hide');
				if(selectedDate !== '') {
					if(!document.querySelector('input[name="toc-chk"]:checked')){
						document.querySelector('.has-errors').innerHTML = 'Please agree to the selected date and terms';
						document.querySelector('.has-errors').classList.remove('hide');
						return false;
					}

					e.target.classList.add('disabled');
					let updateRes = await updateDelivery(orderData);
					if(updateRes.statusCode !== '200'){
						showErrors('There was a problem rescheduling your order. Please contact customer care at 800-766-6786 for assistance.');
					}
					else {
						document.querySelector('section.confirm').insertAdjacentHTML('afterbegin', `<p>Your delivery date has been updated.<br/><a href="${`${redirurl}?orderKey=${orderData.orderKey}`}">Return to Order Details</a></p>`);
						document.querySelector('section.confirm').classList.remove('hide');
						document.querySelector('.main-section').classList.add('hide');
						let premiumDelivery = (orderData.DoorwayDelivery===true) ? true : false;

						dataLayer.push({
							'event': 'changeDeliveryDate',
							'orderStatus': {
								'OrderNumber': orderData.OrderNumber,
								'Status': orderData.orderStatus,
								'DeliveryDate': selectedDate,
								'OrderDate': orderData.OrderDate,
								'Balance': orderData.Balance,
								'OrderTotal': orderData.OrderTotal,
								'Division': orderData.Division,
								'premiumDelivery': premiumDelivery,
								'PaymentType': orderData.PaymentType
							}
						});
					}
				}
				else {
					alert('No Date Selected');
				}
			}
			if(e.target.id == 'close-btn') {
				document.querySelector('.modal').classList.add('hide');
				document.querySelector('.modal-holder').classList.add('hide');
			}

		});

	}else {
		showErrors('No Order Key');

	}
});

const bindCalendarEvents = async () => {
	document.querySelectorAll('.day.date-picker').forEach(item => item.addEventListener('keydown', async function(e){

		let date = date = e.target.dataset.date;
		//console.log(e.target)
		console.log(date)
		switch(e.key){

			case 'ArrowDown':
				date = parseInt(date) + 7;
				if(document.querySelector(`.day[data-date="${date}"]`))
					document.querySelector(`.day[data-date="${date}"]`).focus();
				else
					document.querySelector('button.next:not(.disabled)').focus();
				break;
			case 'ArrowUp':
				date = parseInt(date) - 7;
				if(document.querySelector(`.day[data-date="${date}"]`))
					document.querySelector(`.day[data-date="${date}"]`).focus();
				else
					document.querySelector('button.prev:not(.disabled)').focus();
				break;
			case 'ArrowRight':
				console.log(e.target.dataset.date)
				date++;
				if(document.querySelector(`.day[data-date="${date}"]`))
					document.querySelector(`.day[data-date="${date}"]`).focus();
				else
					document.querySelector('button.next:not(.disabled)').focus();
				break;
			case 'ArrowLeft':
				date--;
				if(document.querySelector(`.day[data-date="${date}"]`))
					document.querySelector(`.day[data-date="${date}"]`).focus();
				else
					document.querySelector('button.prev:not(.disabled)').focus();
				break;
			case 'Enter':
			case ' ':
				e.target.click();
				break;
		}
	}));
};

const buildInterface = async (orderData) => {

	/*flags*/
	let showPayonline = orderData.showPayonline;
	let DoorwayDelivery = orderData.DoorwayDelivery;
	let upgradeDelivery = orderData.upgradeDelivery;
	let deliveryType = orderData.DeliveryType;
	let upgradeAmount = orderData.upgradeInfo ? orderData.upgradeInfo.total : 0;
	let StoreNumber = orderData.StoreNumber;

	let delmsg = await process_delivery_data(orderData);
	if(delmsg!=''){
		document.querySelector('.deliveryinfo .address-line.delivery').innerHTML = delmsg;
	}


	/*DoorwayDelivery and Premium Shipping Upgrade*/
	if(DoorwayDelivery===false && (deliveryType == 'D' || deliveryType == 'K')){
		//professional delivery applied
		//document.querySelector('.deliveryinfo .address-line.upgrade').innerHTML='<span class="bl">Premium Delivery Applied</span>';
		//document.querySelector('.deliveryinfo .address-line.delivered2').innerText = 'Premium delivery includes delivery to any room, professional assembly and removal of packaging.';
		document.querySelector('.deliveryinfo .address-line.delivered2').innerHTML = '<span style="font-style:normal; padding-left:0px">Professional delivery and setup to any room<br/>Premium Delivery includes delivery to any room, professional assembly and removal of packaging.<br/>4-hour delivery window</span><br/><em>We will call 2 day prior with the estimated delivery window.</em>';
		document.querySelector('.deliveryinfo .address-line.delivered2').classList.remove('hide');

	}else{
		if(DoorwayDelivery===true){ /*doorway delivery selected- already upgraded*/
			document.querySelector('.deliveryinfo .address-line.delivered').classList.remove('hide');
			document.querySelector('.deliveryinfo .address-line.delivered').innerText = 'You have chosen Doorway Delivery and your order will be placed inside the garage or entryway of your home. Professional assembly and removal of packaging is not included';
		}
		if(upgradeDelivery===true && deliveryType != 'U'){ /*Can be upgraded*/

			document.querySelector('.deliveryinfo .address-line.upgrade').innerHTML='<span class="">Professional Delivery</span>';

		}
	}

	document.querySelector('.main-section').classList.remove('hide');
	document.querySelector('section.loading').classList.add('hide');
};


const showErrors = (errmsg) => {
	document.querySelector('section.loading').classList.add('hide');
	document.querySelector('section.errors').insertAdjacentHTML('afterbegin', `<p class="error message">${errmsg}</p>`);
	document.querySelector('section.errors').classList.remove('hide');
}

const formatDate = (dt) => {
	dt = dt+'T00:00:00';
	const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
	let dateObj = new Date(dt);
	let month = months[dateObj.getMonth()];
	let day = weekdays[dateObj.getDay()];
	let date = dateObj.getDate();

	let dateHtml = `<div class="date-obj"><div class="month">${month}</div><div class="date">${date}</div><div class="day">${day}</div></div>`;
	return dateHtml;
}

const updateDelivery = async (orderData) => {
	let action = '/deliveryDate';
	let zipcode = orderData.DeliveryAddress.Zip;
	let orderId = orderData.OrderNumber;
	let orderKey = orderData.orderKey;
	let storeNumber = orderData.StoreNumber;
	let division = orderData.Division;
	let deliveryDate = selectedDate;
	let deliveryType = orderData.DeliveryType;
	let phoneNumber = orderData.Customer.PhoneNumber.replace('/','').replace('-','').replace('NPI','');

	const dataObj = {
		orderKey,
		storeNumber,
		deliveryDate
	};

	let dateRes = await fetch(`${ordereendpoint}${action}`, {
		method: 'POST',
		headers: {
		'Content-Type': 'application/json'
		},
		body: JSON.stringify(dataObj)
	});
	let resData = await dateRes.json();
	return resData;

}

const getDeliveryDates = async (orderData) => {
	let action = '/reschedule';
	let zip = orderData.DeliveryAddress.Zip;
	let transactionID = orderData.OrderNumber;
	let isPickup = (orderData.DeliveryType === 'P' ? true : false);
	let existingDate = orderData?.DeliveryDate;
	let skus = [];

	if(orderData.LineItems && orderData.LineItems.LineItem && orderData.LineItems.LineItem.length) {
		orderData.LineItems.LineItem.map(item => {
			console.log(item)

			if(item.ChildItems && item.ChildItems.LineItem && item.ChildItems.LineItem.length) {
				item.ChildItems.LineItem.map(child => {
					if(parseInt(child.Quantity) > 0)
						skus.push(child.Sku);
				})
			}
			else {
				if(item.Sku.indexOf('P') === -1)
					if(parseInt(item.Quantity) > 0)
						skus.push(item.Sku);
			}
		});
	}

	skus = [...new Set(skus)];

	const acctObj = {
		zip,
		transactionID,
		isPickup,
		skus
	};
	if(existingDate && existingDate != '')
		acctObj.existingDate = existingDate;

	let dateRes = await fetch(`${deliveryendpoint}${action}`, {
		method: 'POST',
		headers: {
		'Content-Type': 'application/json'
		},
		body: JSON.stringify(acctObj)
	});
	console.log(dateRes)
	if(dateRes.status !== 200) {
		showErrors('Currently we are unable to schedule your order online, please contact customer care at 800-766-6786 for assistance.');
		document.querySelector('.main-section').classList.add('hide');
		return false;
	}
	let resData = await dateRes.json();

	return resData;
}

const process_delivery_data = async (orderData) => { /*generate display message for delivery info*/

	/*Delivery Types
	D - Adult Delivery
	K - Kids Delivery
	C - Corporate Delivery
	X - Exports Delivery
	Z - Store Pickup
	U - UPS Delivery
	O - Vendor Delivery
	T - GiftCards
	E - Expresss Delivery
	P - Warehouse Pickup
	*/

	/*delivery data*/
	let I95ind = orderData.I95ind;
	let DeliveryDate = orderData.DeliveryDate;
	let deliveryType = orderData.DeliveryType;
	let StoreNumber = orderData.StoreNumber;
	let EstimatedDeliveryTimeFrame = orderData.EstimatedDeliveryTimeFrame;

	let isweb=false;
	if(onlineStores.includes(StoreNumber?.toString())){
		isweb=true;
	}

	if(!['D','K','C','X','Z','U','O','T','E','P'].includes(deliveryType)){ /*if no custom logic, pretends it's D*/
		deliveryType='D';
	}

	let delmsg ='';


	if(!DeliveryDate || DeliveryDate=='' || DeliveryDate.substring(0, 4)=='0001'){
		delmsg = "";
		delmsg = "<strong>Estimated Delivery Notes</strong> Contact Customer Service to Schedule a Delivery Date - (800)766-6786";
		if(deliveryType == 'D' || deliveryType == 'K')
			document.querySelector('.read-terms p').innerHTML = 'I agree to the delivery date of <span class="delivery-date"></span>. I understand that the 4 hour delivery window is within 7am to 10pm and that I will be contacted approximately 2 days prior to be notified of a 4 hour delivery window. Note: Scheduled delivery dates are subject to change. ';
		if(deliveryType == 'P')
			document.querySelector('.read-terms p').innerHTML = 'I confirm that I have chosen <span class="delivery-date"></span> as my pickup date. I understand that the person associated with the billing account must be present at the time of pickup with a valid, government issued ID. I acknowledge that wait time could be up to two hours and that I am responsible for the transportation and assembly of all furniture picked up. If necessary, I will reschedule my pick up date online or by calling customer service at 1-800-766-6786.';
	}else{
		const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];


		let tmpdate = new Date(DeliveryDate.replace('Z',''));

		let delts = Date.parse(DeliveryDate);
		let curts = Date.now();
		let diffts = (delts - curts)/1000;
		let theDeliveryDate = weekdays[tmpdate.getDay()]+ ', '+months[tmpdate.getMonth()]+' '+tmpdate.getDate()+', '+tmpdate.getFullYear();
		selectedDate = tmpdate;

		if(['D','K','C','X'].includes(deliveryType)){
			if(I95ind===true){
				delmsg = "<strong>Date scheduled to leave warehouse</strong>";
				if( diffts < (48*3600)){
					if(diffts < 0 && EstimatedDeliveryTimeFrame==''){
						delmsg += "Has left the warehouse.";
					}else{
						delmsg += EstimatedDeliveryTimeFrame;
						//delmsg+="Should Arrive within "+(Math.ceil(diffts/3600)).toFixed(2)+" hours.";
					}
				}else{
					delmsg+="Specific time frame information is not yet available.<br>Please check back in 48 hours prior to your 4 hour delivery window.";
				}
			}else{
				delmsg = "<strong>Scheduled Delivery Date</strong><span>"+theDeliveryDate+"</span>";
				if( diffts < (48*3600)){
					if(diffts < 0 && EstimatedDeliveryTimeFrame==''){
						delmsg += "Delivered on "+theDeliveryDate;
					}else{
						delmsg += EstimatedDeliveryTimeFrame;
						//delmsg+="Should Arrive within "+(Math.ceil(diffts/3600)).toFixed(2)+" hours.";
					}
				}else{
					delmsg+="Specific time frame information is not yet available.<br>Please check back in 48 hours prior to your 4 hour delivery window.";
				}
			}
		}
		if(deliveryType =='Z'){
			delmsg = "<strong>Store Arrival Date</strong> <span>"+theDeliveryDate+"</span><br>"+
				'<div class="address-line"><strong>'+orderData.PickUpData.StoreName+'</strong></div>'+
				'<div class="address-line">'+orderData.PickUpData.PickupAddress.Address1+'</div>'+
				(orderData.PickUpData.PickupAddress.Address2?'<div class="address-line">'+orderData.PickUpData.PickupAddress.Address2+'</div>':'')+
				'<div class="address-line">'+orderData.PickUpData.PickupAddress.City+' '+orderData.PickUpData.PickupAddress.State+', '+orderData.PickUpData.PickupAddress.Zip+"</div>"+
				'<div class="address-line">Phone: '+orderData.PickUpData.Phone+'</div>';
		}
		if(deliveryType =='P'){
			delmsg = "<strong>Scheduled Pickup Date</strong> <span>"+theDeliveryDate+"</span><br>"+
				'<div class="address-line"><strong>'+orderData.PickUpData.StoreName+'</strong></div>'+
				'<div class="address-line">'+orderData.PickUpData.PickupAddress.Address1+'</div>'+
				(orderData.PickUpData.PickupAddress.Address2?'<div class="address-line">'+orderData.PickUpData.PickupAddress.Address2+'</div>':'')+
				'<div class="address-line">'+orderData.PickUpData.PickupAddress.City+' '+orderData.PickUpData.PickupAddress.State+', '+orderData.PickUpData.PickupAddress.Zip+"</div>"+
				'<div class="address-line">Phone: '+orderData.PickUpData.Phone+'</div>'+
				//'<div class="address-line">Time: '+orderData.PickUpData.PickupHours.string[tmpdate.getDay()]+'</div>';
				'<div class="address-line"><strong>Pickup Hours:</strong></div>';
				if(orderData.PickUpData.PickupHours && orderData.PickUpData.PickupHours.string && orderData.PickUpData.PickupHours.string.length) {
					orderData.PickUpData.PickupHours.string.map((timeframe, i) => {
						delmsg += `<div class="address-line"><span class="day">${weekdays[i]}</span> -&nbsp;&nbsp; ${timeframe}</div>`;
					});
				}
		}
		if(deliveryType =='U'){
			if(isweb){
				delmsg = "<strong>Estimated Delivery Notes</strong> Please check your Order confirmation email for the delivery estimates or call Customer Service at (800)766-6786";
			}else{
				delmsg = "<strong>Estimated Delivery Date</strong> "+theDeliveryDate;
			}
		}
		if(deliveryType =='O'){
			if(isweb){
				delmsg = "<strong>Ships Direct from Vendor</strong>";// Estimated delivery date: "+theDeliveryDate;
			}else{
				delmsg = "<strong>Ships Direct from Vendor</strong>";
			}
		}
		if(deliveryType =='T'){
			if(isweb){
				delmsg = "<strong>Estimated Delivery Notes</strong> Mailed to Billing Address via USPS";
			}else{
				delmsg = "<strong>Estimated Delivery Notes</strong> Contact Showroom for Pickup Date: "+orderData.PickUpData.StoreName;
			}
		}

		if(deliveryType =='E'){

			delmsg = "<strong>Scheduled Delivery Date</strong><span>"+theDeliveryDate+"</span>";
			if( diffts < (48*3600)){
				if(diffts < 0 && EstimatedDeliveryTimeFrame==''){
					delmsg += "Delivered on "+theDeliveryDate;
				}else{
					delmsg += EstimatedDeliveryTimeFrame;
					//delmsg+="Should Arrive within "+(Math.ceil(diffts/3600)).toFixed(2)+" hours.";
				}
			}else{
				delmsg = "<strong>Estimated Delivery Notes</strong> Your delivery has an all day delivery window (7a - 10p). We are unable to establish a specific delivery window because Express Delivery requires such a quick turnaround.";
			}
		}


		if(deliveryType == 'D' || deliveryType == 'K')
			document.querySelector('.read-terms p').innerHTML = 'I agree to the delivery date of <span class="delivery-date">'+theDeliveryDate+'</span>. I understand that the 4 hour delivery window is within 7am to 10pm and that I will be contacted approximately 2 days prior to be notified of a 4 hour delivery window. Note: Scheduled delivery dates are subject to change. ';
		if(deliveryType == 'P')
			document.querySelector('.read-terms p').innerHTML = 'I confirm that I have chosen <span class="delivery-date">'+theDeliveryDate+'</span> as my pickup date. I understand that the person associated with the billing account must be present at the time of pickup with a valid, government issued ID. I acknowledge that wait time could be up to two hours and that I am responsible for the transportation and assembly of all furniture picked up. If necessary, I will reschedule my pick up date online or by calling customer service at 1-800-766-6786.';
	}



	return delmsg;
}
